import { useTheme } from '@/components/ThemeProvider';
import { ISvg, Star } from '../Icon';
import { MouseEvent } from 'react';
import userApiService from '@/request/user/user.api.service';
import { useBoomWallet } from '@boomeme/wallet-sdk';
import { useAuth } from '@/hooks/api/useAuth';
import { useAppEventBusContext } from '@/context/eventBusContext';
import { SubscribeEvent } from '@/interface/event';
import { useAppStore } from '@/store';

interface IProps extends ISvg {
  tokenAddress: string;
}
export default function Index(props: IProps) {
  const { tokenAddress, ...attr } = props;
  const { theme } = useTheme();

  const { walletAddress, isConnected } = useBoomWallet();
  const { followTokenAddressList, setFollowTokenAddressList } = useAppStore();

  const isCancel = isConnected && followTokenAddressList.includes(tokenAddress?.toLocaleLowerCase());
  const { publish } = useAppEventBusContext();

  const followToken = async () => {
    try {
      if (walletAddress && isConnected) {
        const params = {
          walletAddress,
          tokenAddress,
          isCancel,
        };
        const res = await userApiService.followToken(params);
        if (res.code == 0) {
          const tokenAddressList = res.data.map((item) => item.toLocaleLowerCase());
          setFollowTokenAddressList(tokenAddressList);
          publish(SubscribeEvent.Follow_Token, true);
        }
      }
    } catch (error: any) {
      if (error.code == 401) {
        privyAuthLogin();
      }
    }
  };

  const onFollowToken = (e: MouseEvent) => {
    e.stopPropagation();
    if (isConnected) {
      checkState();
    }
  };

  const { checkState, privyAuthLogin } = useAuth(followToken);

  return <Star className="w-[18px] h-[18px]" theme={theme} highlightColor={isCancel ? '#FCD535' : ''} onClick={onFollowToken} {...attr} />;
}
